import React from "react";

export const DisApprove = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.792"
      height="21.053"
      viewBox="0 0 21.792 21.053"
    >
      <path
        id="like_1_"
        data-name="like (1)"
        d="M21.2,16.269H15.09l1.343,3.36a2.581,2.581,0,0,1-.571,2.788,1.951,1.951,0,0,1-2.969-.246L9.338,17.2a16.457,16.457,0,0,0-1.765-2.085l-.45-.45A2.674,2.674,0,0,1,2,13.592V5.035a2.674,2.674,0,0,1,5.123-1.07l.587-.588a3.462,3.462,0,0,1,2.46-1.019H17.1A2.81,2.81,0,0,1,19.67,4.025l3.4,7.655a3.773,3.773,0,0,1,.321,1.532v.867A2.192,2.192,0,0,1,21.2,16.269ZM4.674,3.434a1.6,1.6,0,0,0-1.6,1.6V13.6a1.6,1.6,0,1,0,3.209,0V5.038A1.6,1.6,0,0,0,4.674,3.434Zm17.648,9.777a2.689,2.689,0,0,0-.233-1.1l-3.4-7.647A1.737,1.737,0,0,0,17.1,3.434H10.174a2.4,2.4,0,0,0-1.711.707L7.348,5.26v8.114l.982.982a17.612,17.612,0,0,1,1.88,2.219l3.555,4.974a.877.877,0,0,0,.642.367.889.889,0,0,0,.7-.256,1.514,1.514,0,0,0,.335-1.634L13.8,15.932a.535.535,0,0,1,.5-.733h6.9a1.12,1.12,0,0,0,1.12-1.119Z"
        transform="translate(-1.8 -2.138)"
        fill="#fff"
        stroke="#fff"
        stroke-width="0.4"
      />
    </svg>
  );
};
